import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { appConfig } from './../app.config';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import * as imagesLoaded from 'imagesloaded';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  animations: [
    trigger('fadeIn', [
      state('hidden', style({
        opacity: '0',
        visibility: 'hidden'
      })),
      state('visible',   style({
        opacity: '1',
        visibility: 'visible'
      })),
      transition('hidden => visible', animate('500ms ease-in'))
    ])
  ]
})
export class ImageComponent implements OnInit {
  @Input() image;
  public imageSrcBase = appConfig.imageUrl;

  constructor(
    private elRef: ElementRef
  ) {
  }

  ngOnInit() {
    imagesLoaded(this.elRef, ( instance, image ) => {
      setTimeout(() => {
        this.image.isLoaded = true;
      }, 1000);
    });
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/image/image.component.ts